module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapterNumber",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues2"
    }
  }, [_vm._v("Harold and Enid")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues3"
    }
  }, [_vm._v("Freeway Driving")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues4"
    }
  }, [_vm._v("Starting Over")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues5"
    }
  }, [_vm._v("A Temporary Arrangement")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues6"
    }
  }, [_vm._v("Outside")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues7"
    }
  }, [_vm._v("Sort of Telling It Like It Is")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues8"
    }
  }, [_vm._v("Meetings")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues9"
    }
  }, [_vm._v("Mourning After")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues10"
    }
  }, [_vm._v("Harold and Enid and Abe")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues11"
    }
  }, [_vm._v("Maybe It Wasn’t Necessary . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues12"
    }
  }, [_vm._v(" . . . After All")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues13"
    }
  }, [_vm._v("Western Swing")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues14"
    }
  }, [_vm._v("Goodnight Irene, Goodnight")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues15"
    }
  }, [_vm._v("And All They Will Call You Will Be . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues16"
    }
  }, [_vm._v("Harold and Enid and Abe and Archie")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues17"
    }
  }, [_vm._v("Feeling Tomorrow Like I Feel Today")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues18"
    }
  }, [_vm._v("It Makes Me Think I’m on My Last Go ’Round")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues19"
    }
  }, [_vm._v("Enid and Harold")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/DesertBlues20"
    }
  }, [_vm._v("The Lifetime I’ve Wasted, The Love That I’ve Tasted")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1fcaa3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DesertBlues-1.vue
// module id = 66
// module chunks = 0